
//                       正式地址                   预览地址
// 预售尾款催付   	  presaleExpediting      	presaleExpediting_preview
// 退货提醒       	  goodsBackMind		        goodsBackMind_preview
// 退款成功		        suces				            suces_preview
// 迟发提醒       	  delayMind			          delayMind_preview
// 自动催评  		      autoEvaluation		      autoEvaluation_preview
// 签收提醒     	    recvreMind			        recvreMind_preview
// 百日礼			        hundred_day_gift		    hundred_day_gift_version2
// 申请退款     	    apply				            apply_preview
// 满月礼			        fullmonthgift		        fullmonthgift_version2
// 派件提醒		        delivereMind		        delivereMind_preview
// 拒绝退款     	    deny                    deny_preview
// 常规催付     	    expediting 			        expediting_preview
// 完成提醒		        moneyBack			          moneyBack_preview
// 好评感谢		        thankEvaluation		      thankEvaluation_preview
// 商品销售连带分析 	 goods_combine		       goods_combine_version1
// 商品交易透视 	     goods_analysis		       goods_analysis_version1
// 商品复购周期分析	   goods_repurchase		     goods_repurchase_version1   
// 商品复购         	goods_repurchase    	  goods_repurchase_version2   
// 周年庆			        anniversary			        anniversary_version2
// 同意退款		        agree				            agree_preview
// 取消提醒		        cancelMind			        cancelMind_preview
// 发货提醒		        sendreMind			        sendreMind_preview
// 休眠提醒		        sleep_remind		        sleep_remind_version2
// 付款关怀		        payReminder			        payReminder_preview
// 二次催付		        twiceExpediting		      twiceExpediting_preview
// 中差评安抚		      poorEvaluation		      poorEvaluation_preview
// 下单关怀（货到）	  goodsOrderCare		       goodsOrderCare_preview
// 智能营销	          miDetal		              intelligent_market

/**
 * 1. 菜单无权限时，跳转预览页
 * 2. 预览页无权限时空白页，并提示无权限
*/

// 菜单预览映射表
const obj = {
  presaleExpediting: "presaleExpediting_preview",
  goodsBackMind: "goodsBackMind_preview",
  suces: "suces_preview",
  delayMind: "delayMind_preview",
  autoEvaluation: "autoEvaluation_preview",
  recvreMind: "recvreMind_preview",
  hundred_day_gift: "hundred_day_gift_version2",
  apply: "apply_preview",
  fullmonthgift: "fullmonthgift_version2",
  delivereMind: "delivereMind_preview",
  deny: "deny_preview",
  expediting: "expediting_preview",
  moneyBack: "moneyBack_preview",
  thankEvaluation: "thankEvaluation_preview",
  goods_combine: "goods_combine_version1",
  goods_analysis: "goods_analysis_version1",
  goods_repurchase: "goods_repurchase_version1",
  goods_repurchase: "goods_repurchase_version2",
  anniversary: "anniversary_version2",
  agree: "agree_preview",
  cancelMind: "cancelMind_preview",
  sendreMind: "sendreMind_preview",
  sleep_remind: "sleep_remind_version2",
  payReminder: "payReminder_preview",
  twiceExpediting: "twiceExpediting_preview",
  poorEvaluation: "poorEvaluation_preview",
  goodsOrderCare: "goodsOrderCare_preview",
}

// 自定义路由对应菜单权限映射表
const customObj = {
  miDetal: "intelligent_market",
  peopleFilter: "grouping",
}

// 路由白名单
const whiteList = [
  "",
  "/",
  "/login",
  "/home",
  "/redirection",
  "/jhkGuide",
]

export const checkPermisson = (route) => {
  // 404/模拟登录/白名单 走原来的逻辑
  if(!route.name || whiteList.includes(route.path)) {
    return {
      next: true,
    }
  } else {
    const permission = JSON.parse(localStorage.getItem("permissionPath"))
    const arr = route.path.split("/")
    const pathName = arr[arr.length - 1]
    if(permission.indexOf(pathName) != -1) { // 存在菜单权限
      if(pathName == "goods_repurchase") { // 商品复购-商品复购周期分析path相同单独判断
        if(route.name == "商品复购") { // 商品复购
          if(permission.indexOf("商品复购") != -1) {
            return {
              next: false,
            }
          } else {
            if(permission.indexOf("goods_repurchase_version2") != -1) { // 判断预览页是否有权限
              const newArr = arr.slice(0, arr.length - 1)
              newArr.push("goods_repurchase_version2")
              return {
                next: true,
                path: newArr.join("/")
              }
            } else {
              return {
                next: true,
                path: "/nopermission",
              }
            }
          }
        } else { // 商品复购周期分析
          if(permission.indexOf("商品复购周期分析") != -1) {
            return {
              next: false,
            }
          } else {
            if(permission.indexOf("goods_repurchase_version1") != -1) { // 判断预览页是否有权限
              const newArr = arr.slice(0, arr.length - 1)
              newArr.push("goods_repurchase_version1")
              return {
                next: true,
                path: newArr.join("/")
              }
            } else {
              return {
                next: true,
                path: "/nopermission",
              }
            }
          }
        }
      } else { 
        return {
          next: false,
        }
      }
    } else { // 判断是否有预览页
      let preview = ""
      if(pathName == "goods_repurchase") { // 商品复购-商品复购周期分析path相同单独判断
        if(route.name == "商品复购") {
          preview = "goods_repurchase_version2"
        } else {
          preview = "goods_repurchase_version1"
        }
      } else {
        preview = obj[pathName]
      }
      if(preview && preview !== "") {
        if(permission.indexOf(preview) != -1) { // 判断预览页是否有权限
          const newArr = arr.slice(0, arr.length - 1)
          newArr.push(preview)
          return {
            next: true,
            path: newArr.join("/")
          }
        } else {
          return {
            next: true,
            path: "/nopermission",
          }
        }
      } else { // 此处可能存在非菜单路由权限的判断
        if(checkRouteFatherPermission(pathName)) {
          /**
           * 判断非菜单权限的路由是否有权限
           * 即其对应的父级菜单权限是否有权限
           * 父级菜单存在权限走原来的逻辑
          */
          return {
            next: false,
          }
        } else {
          return {
            next: true,
            path: "/nopermission",
          }
        }
      }
    }
  }
}

// 判断自定义路由对应的父级菜单权限是否有权限
const checkRouteFatherPermission = (pathName) => {
  const str = customObj[pathName]
  const permission = JSON.parse(localStorage.getItem("permissionPath"))
    if(permission.indexOf(str) != -1) { // 存在菜单权限
      return true
    } else {
      return false
    }
}